import { SET_DEPARTMENTS } from '../actions/types';

export default function departmentsReducer(state = [], action) {
	switch (action.type) {
		case SET_DEPARTMENTS:
			return action.payload || [];
		default:
			return state;
	}
}
